/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_Search_ReplaceInputs */



/**
* | output |
* | --- |
* | "Search & Replace" |
*
* @param {Options_Quicktools_Search_ReplaceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_search_replace = /** @type {((inputs?: Options_Quicktools_Search_ReplaceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_Search_ReplaceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher et remplacer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Suchen und Ersetzen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cerca e sostituisci")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Поиск и замена")
	if (locale === "es") return /** @type {LocalizedString} */ ("Buscar y reemplazar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("搜索和替换")
	if (locale === "ja") return /** @type {LocalizedString} */ ("検索と置換")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खोजें और बदलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Localizar e substituir")
	return /** @type {LocalizedString} */ ("Search & Replace")
});